import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

import { mediaMixin, spaceMixin, token } from '@zillow/constellation';

export const StyledLink = styled(Link)`
  margin-right: ${spaceMixin('sm')};
  align-self: baseline;

  &:visited {
    color: ${token('colors.gray600')};
  }

  ${mediaMixin(
    'lg',
    css`
      margin-right: ${spaceMixin('md')};
      margin-top: ${spaceMixin('xs')};
    `,
  )}
`;

type StyledPropertyPhotoContainerProps = {
  primaryPhotoUrl?: string;
  isLoading: boolean;
};
